import * as vp from 'vopay';
import { FunctionComponent, useContext, useMemo } from 'react';
import { DialogueHandler, WebhookDialogueHandler } from './types';
import WebhookContext from './WebhookContext';
import { useTranslation } from 'react-i18next';

const { ConfirmationDialogue } = vp;

type WebhookDialogueProps = {
  handleDialogue: DialogueHandler<WebhookDialogueHandler>;
};

type FC = FunctionComponent<WebhookDialogueProps>;

const WebhookDialogue: FC = ({ handleDialogue }: WebhookDialogueProps) => {
  const {
    showDeactivateErrorAlert,
    showDeactivateSuccessAlert,
    showTestErrorAlert,
    showTestSuccessAlert,
    DeactivateError,
    TestError,
  } = useContext(WebhookContext);
  const { t } = useTranslation('translations', { keyPrefix: 'Settings.Webhooks.Dialogs' });

  return useMemo(
    () => (
      <div>
        {/* Delete User Error */}
        <ConfirmationDialogue
          isVisible={showDeactivateErrorAlert}
          title={t('WebhookNotDeactivated.title')}
          status="error"
          subTitle={`${DeactivateError}`}
          confirm={{
            label: t('WebhookNotDeactivated.confirmButton'),
            action: () => handleDialogue({ type: 'deactivate', state: 'error' }),
          }}
        />
        {/* Delete User Error */}
        <ConfirmationDialogue
          isVisible={showTestErrorAlert}
          title={t('DeleteUserError.title')}
          status="error"
          subTitle={`${TestError}`}
          confirm={{
            label: t('DeleteUserError.confirmButton'),
            action: () => handleDialogue({ type: 'test', state: 'error' }),
          }}
        />
        {/* Delete User Success */}
        <ConfirmationDialogue
          isVisible={showDeactivateSuccessAlert}
          title={t('WebhookSuccessfullyDeactivated.title')}
          status="success"
          subTitle={t('WebhookSuccessfullyDeactivated.subTitle')}
          confirm={{
            label: t('WebhookSuccessfullyDeactivated.confirmButton'),
            action: () => handleDialogue({ type: 'deactivate', state: 'success' }),
          }}
        />
        {/* Delete User Success */}
        <ConfirmationDialogue
          isVisible={showTestSuccessAlert}
          title={t('TestSuccessfullySent.title')}
          status="success"
          subTitle={t('TestSuccessfullySent.subTitle')}
          confirm={{
            label: t('TestSuccessfullySent.confirmButton'),
            action: () => handleDialogue({ type: 'test', state: 'success' }),
          }}
        />
      </div>
    ),
    [showDeactivateErrorAlert, showDeactivateSuccessAlert, showTestErrorAlert, showTestSuccessAlert],
  );
};

export default WebhookDialogue;
